export default function ConversionBlock() {
  return (
    <div className="mt-8">

      {/* 🎴 DARK GLASS CARD */}
      <div className="relative bg-white/[0.03] border border-white/[0.08] rounded-2xl p-6 overflow-hidden backdrop-blur-sm">

        {/* ✨ SUBTLE GLOW */}
        <div className="absolute inset-0 opacity-20 bg-gradient-to-br from-white via-transparent to-transparent pointer-events-none" />

        {/* 🧠 CONTENT */}
        <div className="relative space-y-6 text-center">

          {/* 🔥 HEADLINE */}
          <h2 className="text-lg font-medium text-white/90 leading-snug">
            Your QR is ready.
            <br />
            <span className="text-white/50">
              But it’s still just a PDF.
            </span>
          </h2>

          {/* ⚠️ PROBLEM BLOCK */}
          <div className="bg-white/[0.04] border border-white/[0.08] rounded-xl p-4 text-left space-y-3">

            <p className="text-xs text-white/40 uppercase tracking-wider">
              Limitations
            </p>

            <ul className="text-sm text-white/60 space-y-2">
              <li className="flex items-center gap-2">
                <span className="text-white/30">•</span> No order tracking
              </li>
              <li className="flex items-center gap-2">
                <span className="text-white/30">•</span> No customer data
              </li>
              <li className="flex items-center gap-2">
                <span className="text-white/30">•</span> No repeat marketing
              </li>
            </ul>

          </div>

          {/* 🚀 SOLUTION */}
          <p className="text-sm text-white/50 leading-relaxed">
            Turn your QR into a complete ordering and customer engagement system with Zafflo.
          </p>

          {/* 🎯 CTA */}
          <div className="space-y-3 pt-2">

           {/* PRIMARY */}
<button
  onClick={() => window.open("https://zafflo.com", "_blank")}
  className="w-full bg-white text-black py-3 rounded-xl font-medium text-sm 
  hover:bg-white/90 transition-all duration-200 
  hover:scale-[1.01] active:scale-[0.98]"
>
  Start Taking Orders
</button>

{/* SECONDARY */}
<button
  onClick={() => window.open("https://zafflo.com", "_blank")}
  className="w-full border border-white/[0.15] text-white/70 py-3 rounded-xl text-sm 
  hover:border-white/30 hover:text-white 
  transition-all duration-200 
  hover:scale-[1.01] active:scale-[0.98]"
>
  See Live Demo
</button>

          </div>

          {/* 💡 TRUST */}
          <p className="text-[10px] text-white/30 pt-1">
            Trusted by restaurants, hotels, salons & spas
          </p>

        </div>
      </div>
    </div>
  );
}